import { hashObjectDeep } from '#public/commons-global';
import type {
    CenturyRequest, CenturyResponse, ObjectType,
} from '#public_ts/api/century';

export function useCenturyRowCountCache<O extends ObjectType>() {
    let rowCount = -1;
    let lastFilterHash: string | undefined;

    return (query: CenturyRequest<'list', O>, callback: () => Promise<CenturyResponse<'list', O>>) => {
        const paginator: (typeof query)['paginator'] = { ...query.paginator };
        delete paginator.countRows;

        const query1 = {
            ...query,
            paginator,
        };
        const thisFilterHash = hashObjectDeep(query1);
        if(thisFilterHash !== lastFilterHash) {
            lastFilterHash = thisFilterHash;
            rowCount = -1;
        }
        if(rowCount < 0) {
            paginator.countRows = 'true';
        }
        query.paginator = paginator;
        return callback()
            .then((result) => {
                if(rowCount >= 0) {
                    result.total = rowCount;
                } else {
                    rowCount = Number(result.total);
                }
                return result;
            });
    };
}
